import { getPricingsFromCdnByAgentId, PricingFromCdn } from '@nemuru-eng/js-api-client/slim';

export class GetPricingsFromCdnService {
  private static instance: GetPricingsFromCdnService;
  private agentId: string | null = null;
  public pricings: PricingFromCdn[] | null = null;

  constructor() {}

  public static getInstance() {
    if (!GetPricingsFromCdnService.instance) {
      GetPricingsFromCdnService.instance = new GetPricingsFromCdnService();
    }
    return GetPricingsFromCdnService.instance;
  }

  public async execute(agentId: string): Promise<PricingFromCdn[]> {
    if (this.pricings && this.agentId === agentId) {
      return this.pricings;
    }
    const pricings = await getPricingsFromCdnByAgentId({ agentId });
    this.pricings = pricings;
    this.agentId = agentId;
    return pricings;
  }
}
